class Moodboard {
  constructor(wWidth) {
    this.wWidth = wWidth;
    this.points = [];
    this.lastPoint = null;
    this.hasTouch = true;
    this.parallax = $('div.parallax');
    this.layer = $('.parallax__group');

    this.addScrollHeight();
  }

  addScrollHeight() {
    this.layer.each((i, el) => {
      const $group = $(el);
      $group.css('height', 'auto');
      $group.height($group.get(0).scrollHeight);
    });
  }

  onTouchStart() {
    this.parallax.stop();
    this.startPoint = null;
    this.lastPoint = null;
    this.points = [];
  }

  onTouchMove(e) {
    if (!e) return;

    this.points.push(e.touches[0].pageY);
    if (this.startPoint == null) {
      this.startPoint = e.touches[0].pageY;
    }
    this.lastPoint = e.touches[0].pageY;
  }

  onTouchEnd() {
    if (this.points.length >= 2) {
      const velocity =
        this.points[this.points.length - 1] -
        this.points[this.points.length - 2];
      // const direction = this.startPoint - this.lastPoint >= 0 ? 1 : -1;
      this.parallax.animate(
        { scrollTop: this.parallax.scrollTop() + -20 * velocity },
        {
          duration: Math.ceil(Math.sqrt(Math.abs(velocity)) * 50),
          easing: 'easeOutQuad',
        }
      );
    }
  }

  onResize(wWidth) {
    this.wWidth = wWidth;
    this.addScrollHeight();
  }
}

export default Moodboard;
